import React, { createRef } from "react";
import { gengetURLTEST, genURL } from './../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import SelectFix from "./../PopUp/SelectFix";
import Checkmaingroup from './../CustomFunction/Product/Checkmaingroup'
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import axios from "axios";
import { Row, Grid, Col } from "react-bootstrap";
require('./../_css/PopUpOther.css');
//จำนวนแถว
/* const rowTable = 15; */

export default class PopUpReturnProductSub extends React.Component {

    constructor(props) {
        super(props);
        this.DATA = createRef();
        this.STARTDATE = createRef();
        this.STOPDATE = createRef();
        this.state = {
            col: [],
            rows: [],
            Htext: "",
            SHtype: 3,
            casschkbox: "far fa-square",
            casschkboxs: false,
            openBackdrop: false,
            ckbox_length: 0,
            docno: ""
        }
    }
    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date1 = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date1 + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    Get_Data = () => {
        var dataArray = [];
        var Url = "CSVINVSALEREFSUB/GetDATA2?ARCODE=" + this.props.ARCODE + "&DATA=" + this.DATA.current.value + "&STARTDATE=" + this.STARTDATE.current.value + "&STOPDATE=" + this.STOPDATE.current.value
        console.log(genURL(Url));
        axios.get(genURL(Url)).then(res => {
            var j = 0;
            if (res.data.length > 0) {
                let maingroup
                for (let i = 0; i < res.data.length; i++) {
                    Checkmaingroup(res.data[i].PRODUCTCODE).then(data => { maingroup = data })
                    dataArray[j] = {
                        number: i + 1,
                        Col1: res.data[i].DOCNO,
                        Col2: res.data[i].PRODUCTCODE,
                        Col3: res.data[i].PRODUCTNAME,
                        Col4: res.data[i].UNITNAME,
                        QUANTITY: res.data[i].QUANTITY,
                        UNITPRICE: res.data[i].UNITPRICE,
                        Col9: res.data[i].DISCWORD,
                        Col10: res.data[i].SALENAME,
                        Col11: res.data[i].SALEREMARK,
                        Col13: res.data[i].WAREHOUSE === null ? "" : typeof res.data[i].WAREHOUSE !== undefined ? res.data[i].WAREHOUSE : "",
                        Col14: res.data[i].LOCATION,
                        _unitCode: res.data[i].UNITCODE,
                        _refLineID: res.data[i].REFLINEID,
                        REFQTY: res.data[i].REFQTY,
                        PK_LOTID: res.data[i].PK_LOTID,
                        SB: "0",
                        docgroup: maingroup,
                    }
                    j++;
                }

                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            } else {
                dataArray = [];
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            }
        });
        this.setState({ col: dataArray, Htext: "เลือกรายการย่อย" });
        this.setState({ rows: this.state.rows });
    }
    GetSearchTimeout = () => {
        this.setState({ rows: this.state.col });
    }
    componentDidMount() {
        this.getData()
    }
    getData = async () => {
        this.setState({ openBackdrop: true })
        var dataArray = [];
        var Url = "CSVINVSALEREFSUB/GetDATA2?ARCODE=" + this.props.ARCODE + "&DATA=&STARTDATE=" + this.STARTDATE.current.value + "&STOPDATE=" + this.STOPDATE.current.value
        console.log(genURL(Url));
        await axios.get(genURL(Url)).then(res => {
            var j = 0;
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    dataArray[j] = {
                        number: i + 1,
                        Col1: res.data[i].DOCNO,
                        Col2: res.data[i].PRODUCTCODE,
                        Col3: res.data[i].PRODUCTNAME,
                        Col4: res.data[i].UNITNAME,
                        QUANTITY: res.data[i].QUANTITY,
                        UNITPRICE: res.data[i].UNITPRICE,
                        Col9: res.data[i].DISCWORD,
                        Col10: res.data[i].SALENAME,
                        Col11: res.data[i].SALEREMARK,
                        Col13: res.data[i].WAREHOUSE === null ? "" : typeof res.data[i].WAREHOUSE !== undefined ? res.data[i].WAREHOUSE : "",
                        Col14: res.data[i].LOCATION,
                        _unitCode: res.data[i].UNITCODE,
                        _refLineID: res.data[i].REFLINEID,
                        maingroup: "",
                        STOCKTYPE: res.data[i].STOCKTYPE,
                        ITEMTAXTYPE: res.data[i].ITEMTAXTYPE,
                        productset: res.data[i].PRODUCTSET,
                        REFQTY: res.data[i].REFQTY,
                        PK_LOTID: res.data[i].PK_LOTID,
                        SB: "0",
                    }
                    j++;
                }
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            } else {
                dataArray = [];
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            }

        }).catch(_ => {
            this.setState({ openBackdrop: false })
        }).finally(_ => {
            this.setState({ openBackdrop: false })
        });
        this.setState({ col: dataArray, Htext: "เลือกรายการย่อย" });
    }
    cellcheckbok = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.rows[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0": btnShow = <span>
                <i className="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")}> </i>
            </span>;
                break;
            case "1": btnShow = <span>
                <i className="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}>  </i>
            </span>;
                break;
            default: btnShow = <span><i className="">  </i></span>;
        }
        return (<div>{btnShow}</div>)
    }
    Update_Status = (Row, Status) => {
        if (Status === "ALL") {
            if (this.state.casschkboxs === false) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                var dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                    dataArray[i].SB = "1";
                }
                this.setState({ row: dataArray });
            } else {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                var dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                    dataArray[i].SB = "0";
                }
                this.setState({ row: dataArray });
            }
        } else {
            if (Status === "0") {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: false });
            }
            var dataArray = this.state.rows;
            dataArray[Row].SB = Status;
            this.setState({ rows: dataArray });
            var sb_length = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
                if (this.state.rows[i].SB === "1") { sb_length = sb_length + 1; }
            }
            if (sb_length === this.state.rows.length) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: true });
            }
        }
    }
    onSelectRow = (data, col, id, row) => {
        if (col > 1 && data.Col1) {
            var dataArray = this.state.rows;
            dataArray[id].SB = "1";
            this.setState({ rows: dataArray });
            var reData = [];
            let j = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                if (this.state.rows[i].SB === "1") {
                    reData[j] = this.state.rows[i]
                    j++
                }
            }
            this.props.Get_SelARDepositUse(reData, "", "", "", "");
        }
    }
    onSubmit = () => {
        var reData = [];
        let j = 0;
        var check = false
        for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
            if (this.state.rows[i].SB === "1") {
                check = true
                reData[j] = this.state.rows[i]
                j++
            }
        }
        if (check) {
            this.props.Get_SelARDepositUse(reData, "", "", "", "");
        }
    };
    SelectSetData = (data1, data2) => {
        switch (data1) {
            case "Calendar1":
                this.STARTDATE.current.value = data2
                break
            case "Calendar2":
                this.STOPDATE.current.value = data2
                break
            default:
                break;
        }
    };


    render() {
        return (

            <div className='popup' style={{ 'z-index': '100' }} >
                <Backdrop open={this.state.openBackdrop} />
                <div className='popup_inner'>{/* popup_inner_arinvdebt divBox */}
                    {this.props.Data}
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1">
                            <i className="fas fa-search">{this.state.Htext} </i>
                        </div>
                        <div className="PopUpOtherDivH2" onClick={this.props.closePopup}>
                            <i className="fas fa-times"></i>
                        </div>
                    </div>
                    <div className="panel-body divTable" align="left">
                        <Grid>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Row className="show-grid">
                                    <Col xs={12} sm={4} md={4} lg={4}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <input type="text" className="form-control" placeholder="ค้นหาเลขที่เอกสาร" onKeyUp={(e) => { if (e.key === "Enter") { this.Get_Data() } }} ref={this.DATA} />
                                                    <span className="input-group-addon txt-img icon">
                                                        <i className="fas fa-search" onClick={this.Get_Data}></i>
                                                    </span>
                                                    <span className="input-group-addon txt-img icon">
                                                        <i className="fas fa-sync-alt" onClick={() => { this.getData() }}></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={4} md={4} lg={4}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <span className="input-group-addon">จากวันที่</span>
                                                    <input type="text" className="form-control" ref={this.STARTDATE} name="STARTDATE" />
                                                    <span className="input-group-addon icon">
                                                        <SelectFix type="Calendar1" SelectSetData={this.SelectSetData} />
                                                    </span>
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={4} md={4} lg={4}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <span className="input-group-addon">ถึงวันที่</span>
                                                    <input type="text" className="form-control" ref={this.STOPDATE} name="STARTDATE" />
                                                    <span className="input-group-addon icon">
                                                        <SelectFix type="Calendar2" SelectSetData={this.SelectSetData} />
                                                    </span>
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Grid>

                        <div style={{ marginTop: "10px" }}>

                            <BootstrapTable
                                data={this.state.rows}
                                options={{ onRowClick: this.onSelectRow, noDataText: "ไม่พบข้อมูลที่ค้นหา", }}
                                height="600"
                                hover condensed /* search */>
                                <TableHeaderColumn columnClassName="columnAll columnNumber" className="columnNumber" dataAlign="center" width="35" dataField='number' isKey /* dataFormat={this._chkload.bind(this)} */ ><div onClick={this.props.closePopup}><i className="fas fa-reply-all" ></i> </div></TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="35" dataField='SB' editable={false} dataAlign="center" dataFormat={this.cellcheckbok.bind(this)} > <div onClick={this.Update_Status.bind(null, "", "ALL")} > <i className={this.state.casschkbox}> </i> </div> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="190" dataField='Col1'> เลขที่เอกสาร </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="120" dataField='Col2' > รหัสสินค้า </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="180" dataField='Col3' > ชื่อสินค้า </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col4' dataAlign="left" > หน่วย </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='QUANTITY' dataAlign="left"> ปริมาณ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='UNITPRICE' dataAlign="right"> ราคา/หน่วย </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col9' dataAlign="right"> ลด </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col10' dataAlign="right"> พนักงานขาย </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col11' dataAlign="right"> หมายเหตุพนักงาน </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataAlign="right" dataField='_unitCode' >_unitCode</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataAlign="right" dataField='_refLineID' >_refLineID</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataAlign="right" dataField='maingroup' >Maingroup</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataAlign="right" dataField='STOCKTYPE' >STOCKTYPE</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataAlign="right" dataField='ITEMTAXTYPE' >ITEMTAXTYPE</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataAlign="right" dataField='productset' >productset</TableHeaderColumn>
                                <TableHeaderColumn dataField='Col13' hidden></TableHeaderColumn>
                                <TableHeaderColumn dataField='REFQTY' hidden></TableHeaderColumn>
                                <TableHeaderColumn dataField='PK_LOTID' hidden></TableHeaderColumn>
                                <TableHeaderColumn dataField='Col14' hidden></TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                        <div style={{ float: 'right' }}>
                            {this.state.TableHidden ? ("") : (
                                <button className="PUSDbtn" onClick={this.props.closePopup} >
                                    <i className="fas fa-reply-all"> กลับ </i>
                                </button>
                            )}
                            <button className="PUSDbtn" onClick={this.onSubmit}>
                                <i className="fas fa-check"> ตกลง </i>
                            </button>
                        </div>
                    </div>
                </div >
            </div >
        );
    }
}